import { render, staticRenderFns } from "./BulkImportTemplate.vue?vue&type=template&id=5ced7b40&"
import script from "./BulkImportTemplate.vue?vue&type=script&lang=js&"
export * from "./BulkImportTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports